import { Hero } from "@/components/home/Hero";
import { ServiceAreaStrip } from "@/components/ServiceAreaStrip";
import { About } from "@/components/home/About";
import { ServicesPreview } from "@/components/home/ServicesPreview";
import { Partners } from "@/components/home/Partners";
import { Testimonials } from "@/components/home/Testimonials";
import { CtaBand } from "@/components/CtaBand";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <ServiceAreaStrip />
      <About />
      <ServicesPreview />
      <Partners />
      <Testimonials />
      <div className="pt-24 lg:pt-32">
        <CtaBand />
      </div>
    </main>
  );
}
